import { useState } from "react";
import { Row, Col, Form } from "react-bootstrap";

import { usePpDropdownOptionsQuery } from "api/memberPortal/project/protectionProfiles/protectionProfiles.api";
import ReactSelect from "components/ReactSelect";

export default function PPFormSection({
  editedProduct,
  handleChange,
  ppValid,
  productPps,
  product,
  isRequired = true,
}) {
  const [ppObj] = useState({});

  const { data: allPps = [] } = usePpDropdownOptionsQuery();

  const ppOptions = allPps
    .filter(
      (pp) => !productPps?.some((productPp) => productPp.value === pp.value),
    )
    .sort((a, b) => a.label.localeCompare(b.label));

  const sbomPps = [
    "PP_APP_v1.4",
    "CPP_APP_SW_V1.0e",
    "collaborative Protection Profile for Application Software Version 1.0e",
    "Protection Profile for Application Software Version 1.4",
  ];

  const sbomPpsIds = allPps
    .filter((pp) => sbomPps.includes(pp.label))
    .map((pp) => pp.value);

  const currentPpValues =
    editedProduct?.protection_profile !== undefined
      ? editedProduct.protection_profile
      : (productPps?.map((pp) => pp.value) ?? []);

  const sbomPpSelected = currentPpValues.some((id) => sbomPpsIds.includes(id));

  const showSbomCheckbox = sbomPpSelected || editedProduct?.sbom_submitted;

  return (
    <Row>
      <Form.Label>Protection Profile Claims:{isRequired && "*"}</Form.Label>
      <Form.Group controlId="claim" name="protection_profile">
        <Row>
          <Col>
            <ReactSelect
              isMulti={true}
              options={ppOptions}
              newObj={
                !editedProduct?.protection_profile ? ppObj : editedProduct
              }
              handleChange={handleChange}
              name="protection_profile"
              isValid={ppValid}
              defaultValue={productPps}
              id="checkin-form-pp-select"
            />
          </Col>
        </Row>
      </Form.Group>
      {showSbomCheckbox && (
        <Form.Group className="mt-3 mx-2" controlId="sbom_submitted">
          <Form.Check
            inline
            label={
              <span className="fw-bold">
                Per Policy Letter #30, all evaluations submitted to NIAP for
                evaluation claiming conformance against the AppSW PP or the
                AppSW cPP will be required to include an SBOM. By checking this
                box, you are confirming that the required SBOM has been emailed
                to{" "}
                <span className="text-decoration-underline">
                  sbom@niap-ccevs.org
                </span>{" "}
                prior to submittal of this form
              </span>
            }
            name="sbom_submitted"
            type="checkbox"
            defaultChecked={product.sbom_submitted === true}
            value={editedProduct?.sbom_submitted}
            onChange={handleChange}
            id="sbom_submitted"
            required={sbomPpSelected}
          />
        </Form.Group>
      )}
    </Row>
  );
}
